import { FRONTEND_ROUTES } from "@fysaro/shared";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAppHref } from "@/utils/appUrl";

export function Footer() {
  const { t } = useTranslation(["landing"]);
  const homePath = FRONTEND_ROUTES.public.homeClinic;
  const loginHref = useAppHref(FRONTEND_ROUTES.auth.loginClinic);

  return (
    <footer className="bg-secondary/2 border-t border-border/60 text-foreground py-12 px-6">
      <div className="max-w-7xl px-6 mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* LOGO + DESCRIPCIÓN */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <img
              src="/images/logo_fisio.png"
              alt="Fysaro Logo"
              className="h-8 w-8"
            />
            <span className="text-xl font-black tracking-tight text-primary">
              {t("landing:footer.title")}
            </span>
          </div>
          <p className="text-muted-foreground text-xs leading-relaxed font-medium">
            {t("landing:footer.sub_title")}
          </p>
        </div>

        {/* ENLACES PACIENTE */}
        <div className="space-y-3">
          <h4 className="text-xs font-black uppercase tracking-widest text-muted-foreground">
            {t("landing:footer.links.title")}
          </h4>
          <ul className="space-y-2 text-sm font-medium text-foreground/80">
            <li>
              <a href={`${homePath}#hero`} className="hover:text-primary transition">
                {t("landing:footer.links.home")}
              </a>
            </li>
            <li>
              <a href={`${homePath}#benefits`} className="hover:text-primary transition">
                {t("landing:footer.links.features")}
              </a>
            </li>
            <li>
              <a
                href={`${homePath}#pricing`}
                className="text-primary font-bold hover:underline"
              >
                {t("landing:footer.links.pricing")}
              </a>
            </li>
            <li>
              <a
                href={loginHref}
                className="hover:text-primary transition"
              >
                {t("landing:header.links.login")}
              </a>
            </li>
          </ul>
        </div>

        {/* LEGAL */}
        <div className="space-y-3">
          <h4 className="text-xs font-black uppercase tracking-widest text-muted-foreground">
            {t("landing:footer.legal.title")}
          </h4>
          <ul className="space-y-2 text-sm font-medium text-foreground/80">
            <li>
              <Link
                to={FRONTEND_ROUTES.public.legalPrivacy}
                className="hover:text-primary transition"
              >
                {t("landing:footer.legal.privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={FRONTEND_ROUTES.public.legalTerms}
                className="hover:text-primary transition"
              >
                {t("landing:footer.legal.terms")}
              </Link>
            </li>
            <li>
              <Link
                to={FRONTEND_ROUTES.public.legalCookies}
                className="hover:text-primary transition"
              >
                {t("landing:footer.legal.cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={FRONTEND_ROUTES.public.legalNotice}
                className="hover:text-primary transition"
              >
                {t("landing:footer.legal.legal_notice")}
              </Link>
            </li>
            <li>
              <Link
                to={FRONTEND_ROUTES.public.contact}
                className="hover:text-primary transition"
              >
                {t("landing:footer.legal.contact")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center text-xs text-muted-foreground/60 mt-12 pt-6 border-t border-border/40">
        {t("landing:footer.legal.footer")}
      </div>
    </footer>
  );
}
